import { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "../../components/Button";
import { Colors, TextFont } from "../../config";
import GuestDetails from "./GuestDetails";
import JourneyType from "./JourneyType";
import PassengerDetails from "./PassengerDetails";
import TravelDetails from "./TravelDetails";
import CommentSection from "./CommentSection";

const addGuestImg = require("../../assets/images/add_user.png");
const showFlightsImg = require("../../assets/images/showFlights.png");
const guestBackground = require("../../assets/images/guest_background.png");

const PlanAJourneyRightContainer = ({
  guests,
  onRemove,
  onAddGuests,
  onSubmitRequest,
  handleTimeChange,
  formData,
  passengers,
  setFellowPax,
  airlines,
  setTravelClass,
  handleCheckAirlines,
  fellowPax,
  onFormChange,
  onDateSelection,
  onTimeRangeSelect,
  onDirectFlightToggle,
  onCheckboxChange,
  onPaymentSelect,
  onTravelClassSelect,
  onGuestChange,
  onPassportExpirySelect,
  destinations,
  onDestinationSelect,
  fieldError,
  handleCommentChange,
  handleDobSelect,
  handleUploadPassport,
  fileNames,
  sapErrorList,
  profileData,
  onTypeSelect,
  onFromSelect,
  onPassportNoAndExpiryChange,
  onDependentsPassportUpload,
}) => {
  return (
    <Container>
      <ContainerInnerSection>
        <ContainerHeaderWrapper>
          <TextFont
            fontColor={Colors.brandTwo}
            fontSize="1.5rem"
            fontWeight="700"
          >
            Travel Details
          </TextFont>
          <JourneyType
            returnJourney={formData.returnJourney}
            onTypeSelect={onTypeSelect}
          />
        </ContainerHeaderWrapper>
        <BodyWrapper>
          <TravelDetails
            destinations={destinations}
            onDateSelection={onDateSelection}
            onTimeRangeSelect={onTimeRangeSelect}
            airlines={airlines}
            setTravelClass={setTravelClass}
            handleCheckAirlines={handleCheckAirlines}
            formData={formData}
            onFormChange={onFormChange}
            onDirectFlightToggle={onDirectFlightToggle}
            onDestinationSelect={onDestinationSelect}
            onFromSelect={onFromSelect}
            fieldError={fieldError}
            country={profileData?.territoryName}
            workTerritoryName={
              profileData?.address3 && profileData.address3.trim() !== ""
                ? profileData.address3
                : profileData?.workTerritoryName
            }
          />
          <PassengerDetails
            fellowPax={fellowPax}
            // setFellowPax={setFellowPax}
            formData={formData}
            onCheckboxChange={onCheckboxChange}
            passengers={passengers}
            onPaymentSelect={onPaymentSelect}
            onTravelClassSelect={onTravelClassSelect}
            fieldError={fieldError}
            sapErrorList={sapErrorList}
            profileData={profileData}
            onPassportNoAndExpiryChange={onPassportNoAndExpiryChange}
            onDependentsPassportUpload={onDependentsPassportUpload}
          />
          <CommentSection
            formData={formData}
            handleCommentChange={handleCommentChange}
          />
        </BodyWrapper>
      </ContainerInnerSection>
      {guests?.map((guest, index) => (
        <GuestDetails
          guest={guest}
          index={index}
          onRemove={onRemove}
          onGuestChange={onGuestChange}
          onPaymentSelect={onPaymentSelect}
          onTravelClassSelect={onTravelClassSelect}
          onPassportExpirySelect={onPassportExpirySelect}
          guestError={fieldError.guests && fieldError.guests[index]}
          handleDobSelect={handleDobSelect}
          handleUploadPassport={handleUploadPassport}
          selectedFileName={fileNames[index]}
        />
      ))}
      <DivWrapper>
        <AddGuestWrapper>
          <AddGuestText>Are you traveling with a friend?</AddGuestText>
          <Button
            label="Add Guest"
            rightImgSrc={addGuestImg}
            width="11rem"
            topBottomPadding="0.875rem"
            onClick={(e) => onAddGuests(e)}
          />
        </AddGuestWrapper>
        <FullColumnWrapper>
          <Button
            label="Submit Request"
            rightImgSrc={showFlightsImg}
            width="100%"
            topBottomPadding="0.875rem"
            bgColor={Colors.brandOne}
            onClick={onSubmitRequest}
          />
        </FullColumnWrapper>
      </DivWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 55%;
  background: white;
  height: calc(100vh - 12rem);
  overflow-y: auto;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: ${Colors.brandOne};
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 1rem 0 0;
    box-sizing: border-box;
  }
`;

const ContainerHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 1rem;
  }
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const AddGuestWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  padding: 2rem;
  justify-content: flex-end;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0 1rem;
  }
`;

const AddGuestText = styled.div`
  font-size: 1rem;
  color: ${Colors.shark};
  font-weight: 400;
`;

const FullColumnWrapper = styled.div`
  grid-column: 1 / -1;
  padding: 0rem 2rem 2rem 2rem;
  @media only screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContainerInnerSection = styled.div`
  padding: 2rem 2rem 1rem 2rem;
  @media only screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const DivWrapper = styled.div`
  background: url(${guestBackground}) no-repeat center;
  @media only screen and (max-width: 768px) {
    padding: 2rem;
  }
`;

export default PlanAJourneyRightContainer;
